// --- Core ---
import {useCallback, useEffect} from "react";
import {FieldRenderProps} from "react-final-form";
import {FormattedMessage} from "react-intl";
import {findWhere, map} from "underscore";
// --- Material UI ---
import {Chip} from "@mui/material";
// --- SaniQ ---
import {Role} from "../../../models/Role";
import {MultiSelectField} from "helpers/forms/fields/MultiSelectField";
import {RoleLabel} from "helpers/Roles";
import {useAppDispatch, useAppSelector} from "store";
import {fetchRoles} from "../../../modules/system/modules/roles/actions";

const RoleSelectField = (props: FieldRenderProps<Role[]>) => {
  const dispatch = useAppDispatch();
  const hasLoaded = useAppSelector(state => state.systemContext.roles.hasLoaded);
  const isLoading = useAppSelector(state => state.systemContext.roles.isLoading);
  const roles = useAppSelector(state => state.systemContext.roles.collection);

  useEffect(() => {
    if (!hasLoaded && !isLoading) {
      dispatch(fetchRoles());
    }
  }, [dispatch, hasLoaded, isLoading]);

  const getOptionLabel = useCallback((option: Role) => findWhere(roles, {id: option.id})?.label, [roles]);

  const renderTags = (value: Role[], getTagProps) =>
    map(value, (option, index) => option.type === 'role' ?
      <Chip {...getTagProps({index})} key={index} label={<RoleLabel reference={option}/>}/> : null);

  return (
    <MultiSelectField
      label={<FormattedMessage id="form.roleSelect" defaultMessage="Assigned Roles"/>}
      getOptionLabel={getOptionLabel}
      isOptionEqualToValue={(option: Role, value) => option.id === value.id && option.type === value.type}
      renderTags={renderTags}
      {...props}
      options={roles}
    />
  );
};

export {
  RoleSelectField
};
